<p-toast></p-toast>
<div class="app-verification-container mt-2">
    <!-- <p-card styleClass="p-card-shadow"> -->
    <div class="card dashboardTable">
        <!-- <h4>
                {{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}
            </h4> -->
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                        class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                    icon="pi pi-upload" class="p-button-help"></button>
                <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                    class="p-button-info ml-3"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>

        </p-toolbar>
        <p-table #tankTable [value]="tankData" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
            'srNo', 
            'appID',
            'Applicant_type', 
            'FarmerName',
            'district', 
            'block', 
            'village',  
            'Total_Area', 
            'AgeOfApplication', 
            'LandDetail', 
            'status', 
            'remarks', 
            'DeptRemarks', 
            'FinYear',
            'AssignedDate',
            'ActionDate',
            'UserType',
            'Coverage_Area',
            'NoOfBeneficiary'
            ]"
            responsiveLayout="scroll" [(selection)]="tankData" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loading" sortField="AssignedDate" [sortOrder]="1">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="tankTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>
                    <!-- <th pSortableColumn="srNO">{{'S_NO'| translate}}
                            <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNO"></p-sortIcon>
                        </th> -->

                    <th pSortableColumn="appID">{{'APP_ID'| translate}}
                        <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                        <p-sortIcon field="appID"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Applicant_type">{{'APPLICANT_TYPE'| translate}}
                        <p-columnFilter type="text" field="Applicant_type" display="menu"></p-columnFilter>
                        <p-sortIcon field="Applicant_type"></p-sortIcon>
                    </th>

                    <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                        <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                        <p-sortIcon field="FarmerName"></p-sortIcon>
                    </th>

                    <th pSortableColumn="district">{{'DISTRICT'| translate}}
                        <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                        <p-sortIcon field="district"></p-sortIcon>
                    </th>

                    <th pSortableColumn="block">{{'BLOCK'| translate}}
                        <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                        <p-sortIcon field="block"></p-sortIcon>
                    </th>

                    <th pSortableColumn="village">{{'VILLAGE'| translate}}
                        <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                        <p-sortIcon field="village"></p-sortIcon>
                    </th>



                    <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
                        <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="Total_Area"></p-sortIcon>
                    </th>

                    <th pSortableColumn="AgeOfApplication">{{'AGE_OF_APPLICATION'| translate}}
                        <p-columnFilter type="text" field="AgeOfApplication" display="menu"></p-columnFilter>
                        <p-sortIcon field="AgeOfApplication"></p-sortIcon>
                    </th>

                    <th pSortableColumn="AssignedDate">{{'ASSIGNED_DATE'| translate}}
                        <p-columnFilter type="text" field="AssignedDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="AssignedDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ActionDate">{{'ACTION_DATE'| translate}}
                        <p-columnFilter type="text" field="ActionDate" display="menu"></p-columnFilter>
                        <p-sortIcon field="ActionDate"></p-sortIcon>
                    </th>

                    <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                        <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                    </th>

                    <th pSortableColumn="LandDetail">{{'LAND_DETAIL'| translate}}
                        <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
                        <p-sortIcon field="LandDetail"></p-sortIcon>
                    </th>

                    <th pSortableColumn="DeptRemarks">{{'REMARKS'| translate}}
                        <p-columnFilter type="text" field="DeptRemarks" display="menu"></p-columnFilter>
                        <p-sortIcon field="DeptRemarks"></p-sortIcon>
                    </th>

                    <th pSortableColumn="status">{{'STATUS'| translate}}
                        <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                        <p-sortIcon field="status"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS' | translate}}
                        <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                        <p-sortIcon field="Status_Ar"></p-sortIcon>
                    </th>
                    <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                        <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                        <p-sortIcon field="UserType"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Coverage_Area">{{'COVERAGE_AREA' | translate}}
                        <p-columnFilter type="text" field="Coverage_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="Coverage_Area"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfBeneficiary">{{'NO_OF_BENEFICIARY' | translate}}
                        <p-columnFilter type="text" field="NoOfBeneficiary" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfBeneficiary"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                        <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                        <p-sortIcon field="FinYear"></p-sortIcon>
                    </th>

                    <th>{{'ACTION'| translate}}</th>

                </tr>

            </ng-template>

            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                    <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                            class="p-button-rounded p-button-accent mr-1 btnSize"
                            (click)="selectFarmerApplication(product)"></button></td>
                    <!-- <td>{{rowIndex + 1}}</td> -->
                    <td>{{product.appID}}</td>
                    <td>{{product.Applicant_type}}</td>
                    <td>{{product.FarmerName}}</td>
                    <td>{{product.district}}</td>
                    <td>{{product.block}}</td>
                    <td>{{product.village}}</td>
                    <td>{{product.Total_Area}}</td>
                    <td>{{product.AgeOfApplication}}</td>
                    <td>{{product?.AssignedDate | date:'medium'}}</td>
                    <td>{{product.ActionDate | date:'medium'}}</td>
                    <td>{{product.PendingCompletedDays}}</td>
                    <td>{{product.LandDetail}}</td>
                    <td>{{product.DeptRemarks}}</td>
                    <td>{{product.status}}</td>
                    <td>{{product.Status_Ar}}</td>
                    <td>{{product?.UserType}}</td>
                    <td>{{product?.Coverage_Area}}</td>
                    <td>{{product?.NoOfBeneficiary}}</td>
                    <td>{{product.FinYear}}</td>

                    <!-- <td *ngIf="(product?.PondVerificationStatus == '1') || (product?.PondVerificationStatus == '2')"><button (click)="selectTankRowData(product)" pButton pRipple type="button"
                                label="Fill Details" class="p-button-success mr-2 mb-2"></button></td> -->
                    <td>
                        <button *ngIf="(product?.PondVerificationStatus == '1')" (click)="selectTankRowData(product)"
                            icon="pi pi-pencil" pButton pRipple type="button"
                            class="p-button-rounded p-button-text"></button>
                        <button *ngIf="(product?.PondVerificationStatus == '2')" (click)="selectTankRowData(product)"
                            icon="pi pi-fw pi-plus" pButton pRipple type="button"
                            class="p-button-rounded p-button-text"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex  justify-content-between flex-column ">
                    <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{tankData ? tankData.length : 0 }}
                        {{'APPLICATION_ADDED'| translate}}.
                    </p>
                    <div class="flex  justify-content-between flex-column ">
                        <div class="flex">
                            <div
                                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_BY_ONE_DAY'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'APROVED_ON_TIME'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'DELAYED_APPROVED'| translate}}
                        </div>
                    </div>
                </div>
            </ng-template>

        </p-table>
    </div>
    <!-- </p-card> -->
</div>

<p-dialog [(visible)]="displayTankDialog2" [modal]="true" [style]="{width: '100%',height:'100%'}" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()" [baseZIndex]="-100">

    <div class="app-verification-container">
        <p-card styleClass="p-card-shadow">
            <!-- <h4>List Of Water Tank To Be Verified : Stage-2 (PFMS Module)</h4> -->
            <!-- <div class="card" style="margin: 5px;">
            <p-table #tankTable [value]="dialogData2" [rows]="10" [paginator]="true"
                [globalFilterFields]="['srNo', 'appID','farmerName', 'district', 'block', 'village',  'totalArea', 'ageOfApplication', 'landDetail', 'status', 'remarks']"
                responsiveLayout="scroll" [(selection)]="dialogData" [rowHover]="true" dataKey="id"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNO">Sr. No.
                            <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNO"></p-sortIcon>
                        </th>

                        <th pSortableColumn="appID">APP ID
                            <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                            <p-sortIcon field="appID"></p-sortIcon>
                        </th>

                        <th pSortableColumn="farmerName">Farmer Name
                            <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="farmerName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="district">District
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>

                        <th pSortableColumn="block">Block
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>

                        <th pSortableColumn="village">Village
                            <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                            <p-sortIcon field="village"></p-sortIcon>
                        </th>

                        <th pSortableColumn="totalArea">Total Area
                            <p-columnFilter type="text" field="totalArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="totalArea"></p-sortIcon>
                        </th>

                        <th pSortableColumn="ageOfApplication">Age of Application
                            <p-columnFilter type="text" field="ageOfApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="ageOfApplication"></p-sortIcon>
                        </th>

                        <th pSortableColumn="landDetail">Land Detail
                            <p-columnFilter type="text" field="landDetail" display="menu"></p-columnFilter>
                            <p-sortIcon field="landDetail"></p-sortIcon>
                        </th>

                        <th pSortableColumn="status">Status
                            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>

                        <th pSortableColumn="remarks">Remarks
                            <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="remarks"></p-sortIcon>
                        </th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{rowIndex + 1}}</td>
                            <td>{{product.appID}}</td>
                            <td>{{product.FarmerName}}</td>
                            <td>{{product.district}}</td>
                            <td>{{product.block}}</td>
                            <td>{{product.village}}</td>
                            <td>{{product.Total_Area}}</td>
                            <td>{{product.AgeOfApplication}}</td>
                            <td>{{product.LandDetail}}</td>
                            <td>{{product.status}}</td>
                            <td>{{product.remarks}}</td>
                    </tr>
                </ng-template>

            </p-table>
        </div> -->




            <!-- Table Dialog-2 Starts Here -->
            <!-- <p-table #tankTable [value]="dialogData2" [rows]="6" [paginator]="true"
            [globalFilterFields]="['srNo', 'typeOfFarmer','assistancePaid@', 'subsidyPaidAt1stStage', 'measurementBookTankStage1', 'paymentStatus']"
            responsiveLayout="scroll" [(selection)]="dialogData2" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true">

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="srNO">Sr. No.
                        <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                        <p-sortIcon field="srNO"></p-sortIcon>
                    </th>

                    <th pSortableColumn="typeOfFarmer">Type of Farmer
                        <p-columnFilter type="text" field="typeOfFarmer" display="menu"></p-columnFilter>
                        <p-sortIcon field="typeOfFarmer"></p-sortIcon>
                    </th>

                    <th pSortableColumn="assistancePaid">Assistance Paid @
                        <p-columnFilter type="text" field="assistancePaid" display="menu"></p-columnFilter>
                        <p-sortIcon field="assistancePaid"></p-sortIcon>
                    </th>

                    <th pSortableColumn="subsidyPaidAt1stStage">Subsidy Paid At 1st Stage
                        <p-columnFilter type="text" field="subsidyPaidAt1stStage" display="menu"></p-columnFilter>
                        <p-sortIcon field="subsidyPaidAt1stStage"></p-sortIcon>
                    </th>

                    <th pSortableColumn="measurementBookTankStage1">Measurement Book Tank Stage 1(JE)
                        <p-columnFilter type="text" field="measurementBookTankStage1" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="measurementBookTankStage1"></p-sortIcon>
                    </th>

                    <th pSortableColumn="paymentStatus">Payment Status
                        <p-columnFilter type="text" field="paymentStatus" display="menu"></p-columnFilter>
                        <p-sortIcon field="paymentStatus"></p-sortIcon>
                    </th>

                </tr>

            </ng-template>

            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                <tr>
                    <td>{{rowIndex + 1}}</td>
                        <td>{{product.typeOfFarmer}}</td>
                        <td>{{product.assistancePaid}}</td>
                        <td>{{product.subsidyPaidAt1stStage}}</td>
                        <td>{{product.measurementBookTankStage1}}</td>
                        <td>{{product.paymentStatus}}</td>
                </tr>
            </ng-template>
        </p-table> -->
            <!-- Table Dialog-2 Ends Here -->

            <!-- <div class="col-12"> -->
            <!-- <h4 style="text-align: center;" class="mt-7">Tank Details <span style="color: red;">(Tank Size In Meters
                        Only)</span></h4> -->

            <div class="field-checkbox justify-content-center">
                <label style="margin-right:4px;">{{'SELECT_ACTION'| translate}} </label>
                <p-dropdown [options]='[{name: "Tank Verification"}, {name: "False Intimation"}]' optionLabel="name"
                    (onChange)="wrongNotification2($event)">
                </p-dropdown>
            </div>

            <div class="p-fluid p-formgrid justify-content-center mx-5" style="display: flex; flex-wrap:wrap">
                <div class="field md:col-4 col-12">
                    <label>{{'APPLICATION_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{appID}}</label></label>
                </div>
                <div class="field md:col-4 col-12">
                    <label>{{'APPLICANT_TYPE'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{Applicant_type}}</label></label>
                </div>
                <div class="field md:col-4 col-12">
                    <label>{{'NO_OF_BENEFICIARY'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{noOfBeneficiary}}</label></label>
                </div>
            </div>

            <!-- ESTIMATION FORM -->
            <div *ngIf="wrongNotificationCheck2">
                <div class="col-12">
                    <div class="card intimation-header">
                        <form [formGroup]="submitEstimateFormStage2">
                            <div class="p-fluid p-formgrid grid">
                                <!-- <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="topSizeLength">Top Size :
                                        <div class="d-flex justify-content-around!important">
                                            <div
                                                *ngIf="tankFormControlsStage2.topSizeLength.touched && tankFormControlsStage2.topSizeLength.valid">
                                                Length : {{submitEstimateFormStage2.get('topSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControlsStage2.topSizeBreadth.touched && tankFormControlsStage2.topSizeBreadth.valid">
                                                Breadth : {{submitEstimateFormStage2.get('topSizeBreadth').value}}
                                            </div>
                                        </div>
                                    </label><br><br><br>
                                    <input formControlName="topSizeLength" pInputText id="topSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.topSizeLength.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.topSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.topSizeLength.errors.required">Length is
                                                required
                                            </div>
                                        </div>

                                    <p class="text-center mt-3">X</p>

                                    <input formControlName="topSizeBreadth" pInputText id="topSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.topSizeBreadth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.topSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.topSizeBreadth.errors.required">Breadth
                                                is
                                                required
                                            </div>
                                        </div>
                                </div> -->
                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="topSizeLength">{{'TOP_SIZE_LENGTH'| translate}}:
                                    </label>
                                    <input formControlName="topSizeLength" pInputText id="topSizeLength" type="number"
                                        placeholder="Length"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.topSizeLength.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.topSizeLength.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.topSizeLength.errors.required">
                                            {{'LENGTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="topSizeLength">{{'TOP_SIZE_BREADTH'| translate}}:
                                    </label>
                                    <input formControlName="topSizeBreadth" pInputText id="topSizeBreadth" type="number"
                                        placeholder="Breadth"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.topSizeBreadth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.topSizeBreadth.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.topSizeBreadth.errors.required">
                                            {{'BREADTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="bottomSizeLength">Bottom Size Length:
                                        <div
                                                *ngIf="tankFormControlsStage2.bottomSizeLength.touched && tankFormControlsStage2.bottomSizeLength.valid">
                                                Length : {{submitEstimateFormStage2.get('bottomSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControlsStage2.bottomSizeBreadth.touched && tankFormControlsStage2.bottomSizeBreadth.valid">
                                                Breadth : {{submitEstimateFormStage2.get('bottomSizeBreadth').value}}
                                            </div>
                                    </label><br><br><br>
                                    <input formControlName="bottomSizeLength" pInputText id="bottomSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.bottomSizeLength.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.bottomSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.bottomSizeLength.errors.required">Length
                                                is
                                                required
                                            </div>
                                        </div>

                                    <p class="text-center mt-3">X</p>

                                    <input formControlName="bottomSizeBreadth" pInputText id="bottomSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.bottomSizeBreadth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.bottomSizeBreadth.errors" 
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControlsStage2.bottomSizeBreadth.errors.required">
                                                Breadth is
                                                required
                                            </div>
                                        </div>
                                </div> -->
                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="bottomSizeLength"> {{'BOTTOM_SIZE_LENGTH'| translate}}:

                                    </label>
                                    <input formControlName="bottomSizeLength" pInputText id="bottomSizeLength"
                                        type="number" placeholder="Length"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.bottomSizeLength.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.bottomSizeLength.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.bottomSizeLength.errors.required">
                                            {{'LENGTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="bottomSizeLength">{{'BOTTOM_SIZE_LENGTH'| translate}}:
                                    </label>
                                    <input formControlName="bottomSizeBreadth" pInputText id="bottomSizeBreadth"
                                        type="number" placeholder="Breadth"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.bottomSizeBreadth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.bottomSizeBreadth.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.bottomSizeBreadth.errors.required">
                                            {{'BREADTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="depth">{{'DEPTH'| translate}}: </label>
                                    <input formControlName="depth" pInputText id="depth" type="number"
                                        placeholder="Depth"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.depth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.depth.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.depth.errors.required">{{'DEPTH_IS_REQUIRED'|
                                            translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="typeOfPond">{{'TYPE_OF_POND'| translate}}: </label>
                                    <!-- <p-dropdown [options]="pondType" placeholder="Select Type of Pond"
                                        optionLabel="name" formControlName="typeOfPond"></p-dropdown> -->
                                    <!-- <p-dropdown [options]="pondType"  optionLabel="name" formControlName="typeOfPond"  (onChange)="onPondTypeSelected($event)" [(ngModel)]="PondType"></p-dropdown> -->
                                    <p-dropdown optionValue="name" [options]="pondType" formControlName="typeOfPond"
                                        optionLabel="name" placeholder="Select pond type"></p-dropdown>
                                    <!-- <p-dropdown [options]="pondType" [(ngModel)]="PondType" optionLabel="name" 
                                    placeholder="Select pond type" formControlName="typeOfPond"></p-dropdown> -->
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label
                                        htmlFor="toalCostOfWaterTank">{{'TOTAL_COST_OF_WATER_TANK_(EARTH_WORK_+_CIVIL_WORK_AS_PER_MB)'|
                                        translate}}:
                                    </label>
                                    <input formControlName="toalCostOfWaterTank" pInputText id="toalCostOfWaterTank"
                                        type="number" placeholder="Enter Total Cost of Water Tank"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.toalCostOfWaterTank.errors }"
                                        style="margin-top:4px;" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.toalCostOfWaterTank.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.toalCostOfWaterTank.errors.required">
                                            {{'TOTAL_COST_OF_WATER_TANK_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label
                                        htmlFor="totalAmountOfSubsidy">{{'TOTAL_AMOUNT_OF_SUBSIDY_(@_70%_OF_TOTAL_COST_OF_INDIVIDUAL_OR_@_85%_OF_TOTAL_COST_OF_COMMUNITY_TANK)'|
                                        translate}} :
                                    </label>
                                    <input formControlName="totalAmountOfSubsidy" pInputText id="totalAmountOfSubsidy"
                                        type="number" placeholder="Enter Total Amount of Subsidy"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.totalAmountOfSubsidy.errors }"
                                        style="margin-top:5px;" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.totalAmountOfSubsidy.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.totalAmountOfSubsidy.errors.required">
                                            {{'TOTAL_AMOUNT_OF_SUBSIDY_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label
                                        htmlFor="amountOfTotalSubsidy">{{'60%_OF_TOTAL_ELIGIBLE_ASSISTANCE_INCLUDING_STAGE-1_AFTER_COMPLETION_OF_WATER_TANK_AS_PER_MB'|
                                        translate}} : </label>
                                    <input formControlName="amountOfTotalSubsidy" pInputText id="amountOfTotalSubsidy"
                                        type="number" placeholder="Enter Amount of Subsidy"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.amountOfTotalSubsidy.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.amountOfTotalSubsidy.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.amountOfTotalSubsidy.errors.required">
                                            {{'60%_OF_TOTAL_ELIGIBLE_ASSISTANCE_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck2 && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="StateShare_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="StateShare_Amount"  pInputText id="StateShare_Amount"
                                        type="number" placeholder="State Share Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck2 && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="CenterShare_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="CenterShare_Amount"  pInputText id="CenterShare_Amount"
                                        type="number" placeholder="Center Share Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck2 && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="TopUp">{{'TOP_UP_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="TopUp"  pInputText id="TopUp"
                                    type="number" placeholder="Top Up Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck2 && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="ABY">{{'ABY_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="ABY"  pInputText id="ABY"
                                        type="number" placeholder="ABY Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck2 && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="Coverage_Area">{{'Coverage_Area'| translate}}:
                                    </label>
                                    <input readonly formControlName="Coverage_Area"  pInputText id="Coverage_Area"
                                        type="number" placeholder="Coverage Area"/>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck2">
                                    <label htmlFor="AssistancePaidAtStage1">{{'ASSISTANCE_PAID_AT_STAGE-1'| translate}}:
                                    </label>
                                    <input formControlName="AssistancePaidAtStage1" pInputText
                                        id="AssistancePaidAtStage1" type="number" placeholder="Enter Amount of Subsidy"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControlsStage2.AssistancePaidAtStage1.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.AssistancePaidAtStage1.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControlsStage2.AssistancePaidAtStage1.errors.required">
                                            {{'ASSISTANCE_PAID_AT_STAGE-2_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>


                                <!-- <div class="field col-12 md:col-4" *ngIf="PondVerDataStage2?.length<0"> -->
                                <div class="field col-12 md:col-2"
                                    *ngIf="(router.url.startsWith('/je')) ||(router.url.startsWith('/sdo')) || (router.url.startsWith('/xen'))">
                                    <label htmlFor="block">{{'UPLOAD_MEASUREMENT_BOOK_COPY'| translate}} :</label><br>
                                    <div class="flex" style="margin-top:8px;">
                                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #measurementBookCopyPathStage2
                                            [customUpload]="true"
                                            (uploadHandler)="onUpload($event, 'measurementBookCopyPathStage2', measurementBookCopyPathStage2,1)"
                                            name="myfile[]" mode="basic" [maxFileSize]="1000000" chooseLabel="Browse"
                                            [auto]="true">
                                        </p-fileUpload>
                                        <p-image *ngIf="tankFormControlsStage2.measurementBookCopyPathStage2.value"
                                            [src]="tankFormControlsStage2.measurementBookCopyPathStage2.value"
                                            alt="Image" width="60" class="ml-2 p-button-rounded p-button-success"
                                            iconPos="left">
                                        </p-image>

                                    </div>
                                    <div *ngIf="isSubmitted && tankFormControlsStage2.measurementBookCopyPathStage2.errors"
                                        class="invalid-feedback">
                                        <div
                                            *ngIf="tankFormControlsStage2.measurementBookCopyPathStage2.errors.required">
                                            {{'MEASUREMENT_BOOK_COPY_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="PondVerDataStage2">
                                    <label htmlFor="block">{{'MEASUREMENT_BOOK_COPY_UPLOADED_BY_JE'|
                                        translate}}:</label><br>
                                    <div class="flex" style="margin-top:8px;">
                                        <a style="cursor: pointer;" [href]="PondVerDataStage2.MeasurementCopy"
                                            target="_blank">{{'VIEW_DOC'| translate}}</a>
                                    </div>
                                </div>
                                <div *ngIf="xenLogin || sdoLogin" class="field col-12 md:col-4">
                                    <label htmlFor="farmerName">{{'SURVEY_TYPE'| translate}}</label>
                                    <div class="field-radiobutton d-flex gap-2">
                                        <p-radioButton name="OfficeSurvey" [ngModelOptions]="{standalone: true}"
                                            value="0" (click)="getSurveyType(0)" [(ngModel)]="selectedSurveyType"
                                            inputId="0"></p-radioButton>
                                        <label for="0">From Office</label>
                                        <p-radioButton name="FieldSurvey" [ngModelOptions]="{standalone: true}"
                                            value="1" (click)="getSurveyType(1)" [(ngModel)]="selectedSurveyType"
                                            inputId="1"></p-radioButton>
                                        <label for="1">From Field</label>
                                    </div>
                                </div>
                            </div>


                        </form>

                        <div class="p-fluid p-formgrid grid justify-content-left my-2 remarks">

                            <!-- JE Remarks -->
                            <!-- <div *ngIf="isAdmin || isDMICADA || isDDAssociate || xenLogin"
                                class="field col-12 md:col-2 readOnly">
                                <label htmlFor="pro-data">{{'JE_LATITUDE'| translate}}:</label>
                                <p><label>{{ JElatitude }}</label></p>
                            </div>

                            <div *ngIf="isAdmin || isDMICADA || isDDAssociate || xenLogin"
                                class="field col-12 md:col-2 readOnly">
                                <label htmlFor="pro-data">{{'JE_LONGITUDE'| translate}}:</label>
                                <p><label>{{ JElongitude }}</label></p>
                            </div> -->

                            <div *ngIf="isAdmin || isDMICADA || isDDAssociate || isJEEW || sdoLogin || xenLogin"
                                class="field col-12 md:col-4 readOnly">
                                <label htmlFor="pro-data">{{'JE_REMARKS'| translate}}:</label>
                                <p><label>{{ PondVerDataStage2?.JERemarks }}</label></p>
                            </div>

                            <div *ngIf="isAdmin || isDMICADA || isDDAssociate || isJEEW || xenLogin"
                                class="field col-12 md:col-4 readOnly">
                                <label htmlFor="pro-data">{{'SDO_REMARKS'| translate}}:</label>
                                <p><label>{{ PondVerDataStage2?.SDORemarks }}</label></p>
                            </div>


                            <!-- XEN Remarks -->
                            <div *ngIf="isAdmin || isDMICADA || isDDAssociate || isJEEW" class="field col-12 md:col-4 readOnly">
                                <label htmlFor="pro-data">{{'XEN_REMARKS'| translate}}:</label>
                                <p><label>{{ PondVerDataStage2?.XENRemarks }}</label></p>
                            </div>

                            <div *ngIf="isAdmin || isDMICADA" class="field col-12 md:col-4 readOnly">
                                <label htmlFor="pro-data">{{'DDASSOCIATE_REMARKS'| translate}}:</label>
                                <p><label>{{ PondVerDataStage2?.DARemarks }}</label></p>
                            </div>

                            <div *ngIf="isAdmin" class="field col-12 md:col-4 readOnly">
                                <label htmlFor="pro-data">{{'DMICADA_REMARKS'| translate}}:</label>
                                <p><label>{{ PondVerDataStage2?.DMICADAReamrks }}</label></p>
                            </div>

                            <div *ngIf="isAdmin && adminUpdate" class="field col-12 md:col-4 readOnly">
                                <label htmlFor="pro-data">{{'ADMIN_REMARKS'| translate}}:</label>
                                <p><label>{{ PondVerDataStage2?.AdminRemarks }}</label></p>
                            </div>
                        </div>
                        <div>
                            <span style="font-weight: bold;">{{'NOTE'| translate}}: </span>
                            <span
                                style="color: #EA5455;">{{'ONLY_PDF_FILES_ALLOWED(MAXIMUM_FILE_SIZE_ALLOWED_IS:_1MB/1024KB)'|
                                translate}}</span>
                        </div>
                    </div>


                    <!-- JE GPS coordinates start -->
                    <div class="gps-coordinate-container mt-2">
                        <div class="card">
                            <h5 *ngIf="!jeorxenLogin || xenLogin || sdoLogin">{{'JE_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                                translate}})</h5>
                            <h5 *ngIf="jeLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                            <div class="dashboardTable">
                                <ng-container *ngFor="let array of jegeolocationsarray; let i = index">
                                    <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <p>Table {{ i + 1}}</p>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'CORNER_ID' | translate}}</th>
                                                <th>{{'LATITUDE'| translate}}</th>
                                                <th>{{'LONGITUDE'| translate}}</th>
                                                <th *ngIf="jeLogin && jegeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                            <tr>
                                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                                <td *ngIf="jeLogin" class="surveyEstimateTable">
                                                    <button *ngIf="jegeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('jeLogin', rowIndex, i)"
                                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary" *ngIf="jeLogin">
                                            <button *ngIf="jegeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('jeLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                                class="p-button-info mr-2 mb-2"></button>
                                            <button *ngIf="jegeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('jeLogin', i)" label="{{'Delete Polygon' | translate}}"
                                                class="p-button-danger mr-2 mb-2"></button>
                
                                            <button *ngIf="jegeolocationsarray.length - 1 == i && jegeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('jeLogin', i)" label="{{'Create New Polygon' | translate}}"
                                                class="p-button-warning mr-2 mb-2"></button>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <p-gmap  *ngIf="mapEnableJE" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="jeMapoptions"
                                    [overlays]="jeMapoverlays" (onOverlayDragEnd)="onDrag('jeLogin', $event)"></p-gmap>
                            </div>
                            <div *ngIf="jeLogin" class="my-2 proDataButton flex justify-content-center">
                                <p class="invalid-feedback" *ngIf="jegeolocationsarray && jegeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('jeLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                    class="p-button-secondary mr-2 mb-2"></button>
                            </div>
                        </div>
                        <div *ngIf="jeSurveyLandArea" class="my-2 proDataButton">
                            <p *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length >= 3" class="survey-area">Survey Area: {{ jeSurveyLandArea }} acre(s)</p>
                            <!-- <p *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length >= 3" class="survey-area">Survey Area: {{ jeSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p> -->
                            <p class="invalid-feedback"
                                *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length < 4 && coordinateError">
                                {{coordinateError | translate}}</p>
                        </div>
                    </div>
                    <!-- JE GPS coordinates end -->

                    <!-- SDO GPS coordinates start -->
                    <div *ngIf="(sdoLogin && selectedSurveyType == 1) || !jeLogin && sdogeolocationsarray?.[0]?.length > 0" class="gps-coordinate-container">
                        <div class="card">
                            <h5 *ngIf="!(sdoLogin)">{{'SDO_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                                translate}})</h5>
                            <h5 *ngIf="sdoLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                            <div class="dashboardTable">
                                <ng-container *ngFor="let array of sdogeolocationsarray; let i = index">
                                    <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <p>Table {{ i + 1}}</p>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'CORNER_ID' | translate}}</th>
                                                <th>{{'LATITUDE'| translate}}</th>
                                                <th>{{'LONGITUDE'| translate}}</th>
                                                <th *ngIf="sdoLogin && sdogeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                            <tr>
                                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                                <td *ngIf="sdoLogin" class="surveyEstimateTable">
                                                    <button *ngIf="sdogeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('sdoLogin', rowIndex, i)"
                                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary" *ngIf="sdoLogin">
                                            <button *ngIf="sdogeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('sdoLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                                class="p-button-info mr-2 mb-2"></button>
                                            <button *ngIf="sdogeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('sdoLogin', i)" label="{{'Delete Polygon' | translate}}"
                                                class="p-button-danger mr-2 mb-2"></button>
                
                                            <button *ngIf="sdogeolocationsarray.length - 1 == i && sdogeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('sdoLogin', i)" label="{{'Create New Polygon' | translate}}"
                                                class="p-button-warning mr-2 mb-2"></button>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <p-gmap  *ngIf="mapEnableSDO" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="sdoMapoptions"
                                    [overlays]="sdoMapoverlays" (onOverlayDragEnd)="onDrag('sdoLogin', $event)"></p-gmap>
                            </div>
                            <div *ngIf="sdoLogin" class="my-2 proDataButton flex justify-content-center">
                                <p class="invalid-feedback" *ngIf="sdogeolocationsarray && sdogeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('sdoLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                    class="p-button-secondary mr-2 mb-2"></button>
                            </div>
                        </div>
                        <div *ngIf="sdoSurveyLandArea" class="my-2 proDataButton">
                            <!-- <p *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ sdoSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p> -->
                            <p *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ sdoSurveyLandArea }} acre(s)</p>
                            <p class="invalid-feedback"
                                *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length < 4 && coordinateError">
                                {{coordinateError | translate}}</p>
                        </div>
                    </div>
                    <!-- SDO GPS coordinates end -->

                    <!-- XEN GPS coordinates start -->
                    <div *ngIf="(xenLogin && selectedSurveyType == 1) || !(jeorxenLogin || sdoLogin)" class="gps-coordinate-container">
                        <div class="card">
                            <h5 *ngIf="!(jeorxenLogin || sdoLogin)">{{'XEN_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                                translate}})</h5>
                            <h5 *ngIf="xenLogin || sdoLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                            <div class="dashboardTable">
                                <ng-container *ngFor="let array of xengeolocationsarray; let i = index">
                                    <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <p>Table {{ i + 1}}</p>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'CORNER_ID' | translate}}</th>
                                                <th>{{'LATITUDE'| translate}}</th>
                                                <th>{{'LONGITUDE'| translate}}</th>
                                                <th *ngIf="xenLogin && xengeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                            <tr>
                                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                                <td *ngIf="xenLogin" class="surveyEstimateTable">
                                                    <button *ngIf="xengeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('xenLogin', rowIndex, i)"
                                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary" *ngIf="xenLogin">
                                            <button *ngIf="xengeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('xenLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                                class="p-button-info mr-2 mb-2"></button>
                                            <button *ngIf="xengeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('xenLogin', i)" label="{{'Delete Polygon' | translate}}"
                                                class="p-button-danger mr-2 mb-2"></button>
                
                                            <button *ngIf="xengeolocationsarray.length - 1 == i && xengeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('xenLogin', i)" label="{{'Create New Polygon' | translate}}"
                                                class="p-button-warning mr-2 mb-2"></button>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <p-gmap  *ngIf="mapEnableXEN" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="xenMapoptions"
                                    [overlays]="xenMapoverlays" (onOverlayDragEnd)="onDrag('xenLogin', $event)"></p-gmap>
                            </div>
                            <div *ngIf="xenLogin" class="my-2 proDataButton flex justify-content-center">
                                <p class="invalid-feedback" *ngIf="xengeolocationsarray && xengeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('xenLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                    class="p-button-secondary mr-2 mb-2"></button>
                            </div>
                        </div>
                        <div *ngIf="xenLogin" class="my-2 proDataButton">
                            <!-- <p *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ xenSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p> -->
                            <p *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ xenSurveyLandArea }} acre(s)</p>
                            <p class="invalid-feedback"
                                *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length < 4 && coordinateError">
                                {{coordinateError | translate}}</p>
                        </div>
                    </div>
                    <!-- XEN GPS coordinates end -->



                    <!-- Camera Section -->
                    <div>
                        <div class="card"
                            *ngIf="(router.url.startsWith('/je')) || (router.url.startsWith('/sdo')) || ((router.url.startsWith('/xen') && selectedSurveyType == 1))"
                            style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'UPLOAD_ATTACHMENT'| translate}}</h5>
                            <div class="flex flex-wrap justify-content-center">
                                <!-- <div class="m-2">
                                    <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType"
                                        placeholder="Choose Document Type" optionLabel="name" [showClear]="true">
                                    </p-dropdown>

                                </div> -->
                                <div class="m-2">
                                    <button (click)="openCamera()" pButton pRipple type="button" label="Capture"
                                        class="p-button-success mr-2 mb-2"></button>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <div>
                                        <!-- <div class="document-list">
                                            <div class="document p-fluid p-formgrid grid mt-5"
                                                *ngFor="let item of insertPondAttachments; let i=index">
                                                <div>
                                                    <img [src]="item.attachmentRawUrl"
                                                        style="max-width: 300px; max-height: 300px; display: block;">
                                                </div>
                                                <div class="description">
                                                    <span>
                                                        {{item.displayName}}
                                                        <br>
                                                        <p style="margin-bottom: 0;" *ngIf="item.isUploaded"
                                                            target="_blank"> {{item.name}}</p>
                                                        <p style="margin-bottom: 0;" *ngIf="!item.isUploaded"
                                                            target="_blank"> {{item.name}}</p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="document-list">
                                            <div class="document p-fluid p-formgrid grid mt-2"
                                                style="display: flex; flex-wrap:wrap;">
                                                <div *ngFor="let item of insertPondAttachments; let i=index"
                                                    class="field m-2 p-formgrid" key="index">
                                                    <span style="display: flex; justify-content: space-around">
                                                        <br>
                                                        <p style="margin-bottom: 0;" target="_blank">
                                                            {{item.displayName}} {{item.name}}</p>
                                                        <i class="pi pi-times cross-icon"
                                                            (click)="removeCaptureImg(i)"></i>
                                                    </span>
                                                    <img [src]="item.attachmentRawUrl" [alt]="item.displayName"
                                                        style="max-width: 300px; max-height: 300px; display: block;cursor: pointer" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p-galleria [value]="PondVerDataStage2?.listImagePathJE" [(visible)]="displayCustom"
                            [(activeIndex)]="activeIndex" [responsiveOptions]="responsiveOptions"
                            [containerStyle]="{'max-width': '850px'}" [circular]="true" [fullScreen]="true"
                            [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
                            <ng-template pTemplate="item" let-item>
                                <img [src]="item.ImagePath" style="width: 100%; display: block;" />
                            </ng-template>
                        </p-galleria>
                        <p-galleria [value]="PondVerDataStage2?.listImagePathSDO" [(visible)]="displayCustom"
                            [(activeIndex)]="activeIndex" [responsiveOptions]="responsiveOptions"
                            [containerStyle]="{'max-width': '850px'}" [circular]="true" [fullScreen]="true"
                            [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
                            <ng-template pTemplate="item" let-item>
                                <img [src]="item.ImagePath" style="width: 100%; display: block;" />
                            </ng-template>
                        </p-galleria>
                        <p-galleria [value]="PondVerDataStage2?.listImagePathXEN" [(visible)]="XENdisplayCustom"
                            [(activeIndex)]="XENactiveIndex" [responsiveOptions]="responsiveOptions"
                            [containerStyle]="{'max-width': '850px'}" [circular]="true" [fullScreen]="true"
                            [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
                            <ng-template pTemplate="item" let-item>
                                <img [src]="item.ImagePath" style="width: 100%; display: block;" />
                            </ng-template>
                        </p-galleria>


                        <!-- <div class="card" *ngIf="prev" style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'PREVIOUS_ATTACHMENTS'| translate}}</h5>
                            <div class="p-fluid p-formgrid grid">
                                <div *ngFor="let image of PondVerDataStage2?.listImagePath; let index = index;"
                                    class="field m-3" key="index">
                                    <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                                        (click)="imageClick(index)" style="max-width: 300px; max-height: 300px;" />
                                    <div class="flex flex-wrap justify-content-center">
                                        <div>{{image.DocumentType}}</div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="card" *ngIf="prev && !jeLogin" style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'JE_ATTACHMENTS'| translate}}</h5>
                            <div class="document p-fluid p-formgrid grid" style="display: flex; flex-wrap:wrap;">
                                <div class="field m-2" key="index"
                                    *ngFor="let image of PondVerDataStage2?.listImagePathJE; let index = index;">
                                    <span style="display: flex; justify-content: space-around">
                                        <br>
                                        <p style="margin-bottom: 0;" target="_blank">{{image.DocumentType}}</p>
                                    </span>
                                    <img [src]="image.ImagePath" [alt]="image.DocumentType" (click)="imageClick(index)"
                                        style="max-width: 300px; max-height: 300px; display: block;cursor: pointer" />
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="card" *ngIf="SDOprev && !sdoLogin && !jeLogin" style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'SDO_ATTACHMENTS'| translate}}</h5>
                            <div class="document p-fluid p-formgrid grid" style="display: flex; flex-wrap:wrap;">
                                <div class="field m-2" key="index"
                                    *ngFor="let image of PondVerDataStage2?.listImagePathSDO; let index = index;">
                                    <span style="display: flex; justify-content: space-around">
                                        <br>
                                        <p style="margin-bottom: 0;" target="_blank">{{image.DocumentType}}</p>
                                    </span>
                                    <img [src]="image.ImagePath" [alt]="image.DocumentType" (click)="imageClick(index)"
                                        style="max-width: 300px; max-height: 300px; display: block;cursor: pointer" />
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="card" *ngIf="XENprev && !xenLogin && !sdoLogin && !jeLogin"
                            style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'XEN_ATTACHMENTS'| translate}}</h5>
                            <div class="p-fluid p-formgrid grid" style="display: flex; flex-wrap:wrap;">
                                <div class="field m-2" key="index"
                                    *ngFor="let image of PondVerDataStage2?.listImagePathXEN; let index = index;">
                                    <div>
                                        <span style="display: flex; justify-content: space-around">
                                            <br>
                                            <p style="margin-bottom: 0;" target="_blank">{{image.DocumentType}}</p>
                                        </span>
                                        <img [src]="image.ImagePath" [alt]="image.DocumentType"
                                            (click)="XENimageClick(index)"
                                            style="max-width: 300px; max-height: 300px; display: block;cursor: pointer">
                                    </div>
                                </div>
                            </div>
                        </div>


                        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true"
                            [draggable]="false" [style]="{width: '98vw'}" [resizable]="false"
                            (onHide)="onCloseCameraDialog()">
                            <div *ngIf="displayCameraComponent">
                                <div class="camera-container">
                                    <div *ngIf="locationError" style="color: red; font-weight: bold;">
                                        {{locationError}}
                                    </div>
                                    <div *ngIf="!imageCaptured">
                                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                                            *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
                                            [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
                                            (cameraSwitched)="cameraWasSwitched($event)"
                                            (initError)="handleInitError($event)"></webcam>
                                        <br />
                                    </div>

                                    <h4 *ngIf="errors.length > 0">{{'MESSAGES'| translate}}:</h4>
                                    <ul *ngFor="let error of errors">
                                        <li>{{error | json}}</li>
                                    </ul>
                                </div>
                                <div class="webcam-btn" *ngIf="!imageCaptured">
                                    <button pButton pRipple type="button" label="capture" class="p-button-success m-2"
                                        (click)="triggerSnapshot()"></button>
                                    <button pButton pRipple type="button" label="switch camera"
                                        class="p-button-success m-2" (click)="showNextWebcam(true)"></button>
                                </div>
                                <div class="snapshot" *ngIf="imageCaptured">
                                    <img [src]="webcamImage.imageAsDataUrl" />
                                    <div *ngIf="fencingError" style="color: red; font-weight: bold; margin-top:10px;">
                                        {{fencingError}}
                                    </div>
                                </div>
                                <div class="webcam-btn" *ngIf="imageCaptured">
                                    <button pButton pRipple type="button" label="Upload" class="p-button-success m-2"
                                        (click)="uploadPicture()" [disabled]="!isInsideFencing"></button>
                                    <button pButton pRipple type="button" label="Retake" class="p-button-success m-2"
                                        (click)="retake()"></button>
                                </div>
                            </div>
                        </p-dialog>
                    </div>

                    <!-- Camera Section End -->

                </div>

                <div class="card dropdown-content" style="margin: 5px;">
                    <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                        <div class="field col-12 md:col-4">
                            <br>
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                class="mr-3"></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-2">
                            <textarea id="description" [(ngModel)]="stage2EstimateFormremarks" placeholder="Remarks"
                                pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
                        </div>
                        <div class="field col-12 md:col-2">
                            <br>
                            <!-- <button pButton pRipple label="Submit" type="submit" [disabled]="canEditPondData" (click)="submitEstimateStage2()"
                                class="p-button-help"></button> -->
                            <button pButton pRipple label="Submit" type="submit" (click)="submitEstimateStage2()"
                                class="p-button-help"></button>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template [ngIf]="!wrongNotificationCheck2">
                <div class="col-12">
                    <div class="card intimation-header">
                        <form [formGroup]="submitFalseIntimateFormStage2" (onChange)="wrongNotification2($event)">

                            <div class="p-fluid p-formgrid grid">
                                <!-- <div class="field col-12">
                                <label htmlFor="applicationID">Application ID : {{appID}}</label>
                            </div> -->

                                <div class="field col-12 md:col-4">
                                    <label htmlFor="block">{{'UPLOAD_THE_PHOTO_TAKEN'| translate}}* : </label>
                                    <div class="flex">
                                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #uploadThePhotoTaken
                                            [customUpload]="true"
                                            (uploadHandler)="onUpload($event, 'uploadThePhotoTaken', uploadThePhotoTaken,2)"
                                            name="myfile[]" mode="basic" [maxFileSize]="1000000" chooseLabel="Browse"
                                            [auto]="true">
                                        </p-fileUpload>
                                        <p-image *ngIf="falseIntimationFormControlsStage2.uploadThePhotoTaken.value"
                                            [src]="falseIntimationFormControlsStage2.uploadThePhotoTaken.value"
                                            alt="Image" width="60" class="ml-2 p-button-rounded p-button-success"
                                            iconPos="left"></p-image>
                                    </div>
                                </div>

                                <!-- <div class="field col-12 md:col-2" *ngIf="(router.url.startsWith('/sdo')) || (router.url.startsWith('/xen'))">
                                    <label htmlFor="block">Photo taken:</label><br>
                                    <div class="flex" style="margin-top:8px;">
                                        <a style="cursor: pointer;" [href]="tankData[0]" target="_blank">View doc</a>
                                    </div>
                                </div> -->
                            </div>
                            <br>
                            <div>
                                <span style="font-weight: bold;">{{'NOTE'| translate}}: </span>
                                <span style="color: #EA5455;">{{'ONLY_JPG,PNG_OR_PDF_PHOTO_ALLOWED'| translate}}.</span>
                            </div>
                            <br>
                        </form>
                    </div>
                </div>
                <div class="card dropdown-content" style="margin: 5px;">
                    <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                        <div class="field col-12 md:col-4">
                            <!-- <p-dropdown [options]="items" [(ngModel)]="selectedStatus" [disabled]="canEditPondData"
                                optionLabel="status" class="mr-3"></p-dropdown> -->
                            <p [style]="{'color': 'black'}"><b>{{ selectedStatusFalseIntimation?.status }}</b></p>
                        </div>
                        <div class="field col-12 md:col-2">
                            <textarea id="description" [(ngModel)]="stage2FalseIntimationremarks"
                                [disabled]="canEditPondData" placeholder="Remarks" pInputTextarea required rows="3"
                                cols="20" class="mr-3"></textarea>
                        </div>
                        <div class="field col-12 md:col-2">
                            <button pButton pRipple label="Submit" type="submit" [disabled]="canEditPondData"
                                (click)="submitFalseIntimateStage2()" class="p-button-help"></button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- </div> -->
        </p-card>

        <div class="card mt-2" reflow="true">
            <div *ngIf="viewWorkFlowAllStatus">
                <app-work-flow-all-status [applicationId]="appID"></app-work-flow-all-status>
            </div>
            <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
                class="p-button-secondary" (click)="workFlowAllStatus()"></button>
        </div>
    </div>
</p-dialog>


<p-dialog [(visible)]="displayFileDialog" [modal]="true" [style]="{margin : '3rem'}" [maximizable]="true"
    [draggable]="false" [resizable]="true" (onHide)="onCloseFileDialog()" [baseZIndex]="-100">
    <ng-template pTemplate="header">
        <div>
            <button pButton pRipple icon="pi pi-search-plus" class="p-button-text"
                (click)="transformImage(null, 'zoom-in')" [disabled]="numberEquals(scalingAmount, 1)"></button><br />
            <button pButton pRipple icon="pi pi-search-minus" class="p-button-text"
                (click)="transformImage(null, 'zoom-out')" [disabled]="numberEquals(scalingAmount, '0.1')"></button>
        </div>
    </ng-template>
    <embed [src]="getSafeUrl()" style="width: 100%; height: 100%;" id="myname" #myname>

    <ng-template pTemplate="footer">
        <div class="flex flex-wrap align-items-center justify-content-center">
            <button pButton pRipple label="Rotate Left" icon="pi pi-angle-left" class="p-button-success"
                (click)="transformImage('left', null)"></button>
            <button pButton pRipple label="Rotate Right" icon="pi pi-angle-right" class="p-button-success"
                (click)="transformImage('right', null)"></button>
        </div>
    </ng-template>
</p-dialog>